/* eslint-disable @typescript-eslint/no-var-requires */
// ! Будет ли это решение работать внутри сервис воркеров?
// ! Вряд ли будет, но сейчас это и не нужно, скорее всего.
const base = typeof window === "undefined"
  ? require("./baseUrl").default // Для серверного окружения берём baseUrl
  : window.location.origin // Для браузерного - достаём из location

// TODO: Тут было бы неплохо тесты написать - они довольно простые будут
function isUrlExternal(url: string): boolean {
  // Относительные ссылки всегда внутренние
  if (!/^(?:https?:)\/\//.test(url)) {
    return false
  }

  return !url.startsWith(new URL(base).origin)
}

export default isUrlExternal
